import { clsx } from 'clsx';

import type { QueryBuilderChangeEvent } from '../../types/QueryBuilder';

import { QueryBuilderContext } from './context';
import { useQueryBuilderSetup } from './hooks/useQueryBuilderSetup';

import styles from './QueryBuilder.module.css';

interface QueryBuilderProps {
  /** Controlled query string. When provided, external changes sync into internal state. */
  value?: string;
  /** Initial query string for uncontrolled usage. */
  defaultValue?: string;
  /** Called whenever the committed query changes. */
  onChange?: (event: QueryBuilderChangeEvent) => void;
  /** Additional class name(s) merged with the built-in root class via clsx. */
  className?: string;
  children: React.ReactNode;
}

export function QueryBuilder({ value, defaultValue, onChange, className, children }: QueryBuilderProps) {
  const { contextValue, wrapperRef } = useQueryBuilderSetup({ value, defaultValue, onChange });

  return (
    <QueryBuilderContext.Provider value={contextValue}>
      <div ref={wrapperRef} className={clsx(styles.root, className)}>
        {children}
      </div>
    </QueryBuilderContext.Provider>
  );
}

QueryBuilder.displayName = 'QueryBuilder';
